<template>
    <div id="chukgl">
        <div class="fflex ffbet" >
            <ul class="fflex headBox">
                <li @click="jump('kcshanglei')">库存列表</li>
<!--                <li @click="jump('kcbaobiao')">库存报表</li>-->
                <li class="active">盘点单</li>
                <li  @click="jump('kcchuru')">出入库明细</li>

            </ul>
            <div class=" ">

            </div>
        </div>

        <div class="fflex ffend" style="margin: 10px 0;line-height: 32px;color: #999">

            <div>

                <el-date-picker
                        style="width: 260px;margin-right: 10px"
                        v-model="setime"
                        size="small"
                        :name="['time_s','time_e']"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>

                <span>盘点人：</span>
                <select name=""  class="xiala "  style="width: 120px;margin-right: 10px;margin-left: 5px" v-model="person" >
                    <option value="">请选择</option>
                    <option :value="go.user_id" v-for="go in goodsleiop">{{go.username}}</option>


                </select>
                <el-button type="success"  size="mini" style="margin-right: 10px" @click="chaxun" >查询</el-button>
                <el-button type="success" round size="mini" class="purBtnsz" style="height: 28px;"  @click="tianjrk">添加盘点单</el-button>
            </div>




        </div>

        <div class="tableBox">
            <table class="table table-bordered" >
                <thead>
                <tr>
                    <th>序号</th>
                    <th>盘点单号</th>
                    <th>盘点日期</th>
                    <th>创建日期</th>
                    <th>盘点人</th>
                    <th>操作</th>



                </tr>
                </thead>
                <tbody>
                <tr v-for="(ta,taindex) in tabledata" :key="taindex">
                    <td>{{taindex+1}}</td>
                    <td >{{ta.order_num}}</td>
                    <td >{{ta.date}}</td>
                    <td >{{ta.create_time}}</td>
                    <td >{{ta.person}}</td>

                    <td >
                      <span class="tablebtnBox">
                          <div class="qianziBtn-mini"
                               style="background: rgb(0, 204, 228);color: #fff" @click="tan(ta.id)"  >查看</div>

                          <!--<div class="shenziBtn-mini" @click="tan(3)" >修改</div>-->
                          <div class="qianziBtn-mini" @click="delfn(ta.id)"
                               style="background: rgb(255, 121, 124);color: #fff"  >作废</div>
                    </span>
                    </td>

                </tr>

                </tbody>
            </table>
            <p>共有{{total}}条记录  当前{{currentpage}}页/共{{pagetotal}}页</p>
        </div>

        <div class="table-bottom">
            <div>
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="currentpage"
                        :page-size="pageone"
                        background
                        layout="prev, pager, next"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <!--查看盘点单ssss-->
        <el-dialog
                class="tanchuang"
                title="查看盘点单"
                :visible.sync="chukglt"
                width="1000px"
        >
            <div style="height: 60vh;overflow-y: scroll">
                <el-row >
                    <el-col :span="12" class="marBo2" style="height: 32px;line-height: 32px">
                        <span class="inputT">盘点日期：</span>
                        <span class="inputT">{{Korder_info.date}}</span>
                    </el-col>
                    <el-col :span="12" class="marBo2" style="height: 32px;line-height: 32px">
                        <span class="inputT">盘点人：</span>
                        <span class="inputT">{{Korder_info.person}}</span>
                    </el-col>

                    <el-col :span="24" class="marBo2">
                        <span class="inputT" style="padding-bottom: 10px;vertical-align: top">	备注：</span>
                        <el-input
                                style="width: 82%"
                                disabled
                                v-model="Korder_info.notes"
                                type="textarea"
                                :autosize="{ minRows: 2}"
                        >
                        </el-input>
                    </el-col>

                    <el-col :span="24" v-if="zhuang==1" style="text-align: center;margin-bottom: 10px">
                        <el-button type="success" round size="mini" class="purBtnsz" @click="tianj">添加商品</el-button>
                    </el-col>
                    <el-col :span="24">
                        <div class="tableBox" style="overflow-x: scroll">
                            <table class="table table-bordered" >
                                <thead>
                                <tr>
                                    <th>商品编号</th>
                                    <th>商品名称</th>
                                    <th>图片</th>
                                    <th>规格</th>
                                    <th>单位</th>
<!--                                    <th>价格</th>-->
                                    <th>库存数量</th>
                                    <th>实盘数量</th>
                                    <th>损益数量</th>

                                    <th>备注</th>

                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(kog,koindex) in Korder_goods" :key="koindex">

                                    <td >
                                       {{kog.good_num}}
                                    </td>
                                    <td >{{kog.good_name}}</td>
                                    <td >
                                        <a :href="kog.imgpath">
                                        <img style="width: 25px;height: 25px" :src="kog.imgpath" alt="">
                                        </a>
                                    </td>
                                    <td >{{kog.spec}}</td>
                                    <td >{{kog.unit}}</td>
<!--                                    <td >{{kog.price}}</td>-->
                                    <td >{{kog.pd_stock}}</td>
                                    <td >{{kog.pd_number}}</td>
                                    <td >{{kog.number}}</td>
                                    <td>{{kog.good_notes}}</td>

                                </tr>

                                </tbody>
                            </table>
                            <p>共有{{total}}条记录  当前{{currentpage}}页/共{{pagetotal}}页</p>
                        </div>
                    </el-col>



                    <el-col :span="24" v-if="zhuang==1" style="text-align: center">
                        <el-button type="success" round size="mini" class="purBtnsz" @click="tianj">确认添加</el-button>
                    </el-col>

                </el-row>
            </div>
        </el-dialog>
        <!--查看盘点单eeee-->

        <!--添加盘点单ssss-->
        <el-dialog
                class="tanchuang"
                title="添加盘点单"
                :visible.sync="ruglt2"
                width="1000px"
        >
            <form id="ruku" style="height: 450px;overflow-y: scroll"  method='post'  enctype="multipart/form-data">
                <input type="hidden"  name="token" v-model="token">
                <el-row >
                    <el-col :span="12" class="marBo2" style="height: 32px;line-height: 32px">
                        <span class="inputT">盘点日期：</span>
                        <!--<span class="inputT">{{addmeg.date}}</span>-->
                        <el-date-picker
                                style="width: 150px"
                                name="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                size="small"
                                v-model="addmeg.date"
                                type="date"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="12" class="marBo2" style="height: 32px;line-height: 32px">
                        <span class="inputT">盘点人：</span>
                        <span class="inputT">{{addmeg.user_name}}</span>
                    </el-col>



                    <el-col :span="24" class="marBo2">
                        <span class="inputT" style="padding-bottom: 10px;vertical-align: top">	备注：</span>
                        <el-input
                                style="width: 82%"
                                name="notes"
                                v-model="addmeg.notes"
                                type="textarea"
                                :autosize="{ minRows: 2}"
                        >

                        </el-input>
                    </el-col>

                    <el-col :span="24"  style="text-align: center;margin-bottom: 10px">
                        <el-button type="success" round size="mini" class="purBtnsz" @click="tianjshangp">添加商品</el-button>
                    </el-col>
                    <el-col :span="24">
                        <div class="tableBox" style="overflow-x: scroll">
                            <table class="table table-bordered" >
                                <thead>
                                <tr>

                                    <th>商品编号</th>
                                    <th>商品名称</th>
                                    <th>图片</th>

                                    <th>规格</th>
                                    <th>单位</th>

<!--                                    <th>价格</th>-->

                                    <th>库存数量</th>
                                    <th>实盘数量</th>
                                    <th>损益数量</th>

                                    <th>备注</th>
                                    <th>操作</th>


                                </tr>
                                </thead>


                                <tbody>
                                <tr v-for="(ord,oindex) in order_goods2" :key="oindex" >

                                    <td >
                                        {{ord.good_num}}
                                        <input type="hidden" name="goods_id[]" v-model="ord.id">
                                    </td>
                                    <td >{{ord.good_name}}</td>
                                    <td ><img style="width: 25px;height: 25px" :preview="oindex+1"  :src="ord.imgpath" alt=""> </td>
                                    <td >{{ord.spec}}</td>
                                    <td >{{ord.unit}}	</td>

<!--                                    <td >-->
<!--                                        <input name="price[]"  type="number" style="width: 50px" v-model="ord.real_price">-->
<!--                                    </td>-->
                                    <td>
                                       {{ord.stock}}
                                        <input type="hidden" name="pd_stock[]" v-model="ord.stock">
                                    </td>
                                    <td >
                                        <input type="number" min="0"  name="number[]" style="width: 50px" v-model="ord.ship">
                                    </td>
                                    <td ref="jiage" >
                                        {{(ord.ship==undefined ? 0 : ord.ship)-(ord.stock==undefined ? 0 : ord.stock)}}
                                    </td>
                                    <td ><input type="text"  name="good_notes[]"  v-model="ord.good_notes"></td>
                                    <td @click="deletefn(oindex)">删除</td>

                                </tr>


                                </tbody>
                            </table>

                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div style="display: flex;justify-content: center;align-items: center;margin-top: 15px;margin-bottom: 15px">
                            <el-button type="success" round size="mini" class="purBtnsz" style="height: 28px;" @click="quetj" >确认添加</el-button>
                        </div>
                    </el-col>



                </el-row>
            </form>

        </el-dialog>
        <!--添加盘点单eeee-->

        <!--选择商品sss-->
        <el-dialog
                class="tanchuang"
                title="选择商品"
                :visible.sync="goodschecked"
                width="70%"
        >

            <div style="height: 450px;overflow-y: scroll">
                <el-row >


                    <el-col :span="7" class="marBo2">
                        <span class="inputT" style="width: auto;padding-right: 10px">商品类别：</span>
                        <!--<span class="inputT">{{order_info.express_price}}</span>-->
                        <select name=""  class="xiala" v-model="Ggtype" style="width: 100px" :disabled="dis">
                            <option value="">请选择</option>
                            <option :value="g.id" v-for="(g,gindex) in Ggood_types" :key="gindex">{{g.type_name}}</option>
                        </select>

                    </el-col>
                    <el-col :span="7" class="marBo2">
                        <span class="inputT" style="width: auto;padding-right: 10px">供应商：</span>
                        <select name="" v-model="Gsup" class="xiala" style="width: 100px" :disabled="dis">
                            <option value="">请选择</option>
                            <option :value="su.id" v-for="(su,suindex) in Gsuppliers" :key="suindex">{{su.supplier_name}}</option>
                        </select>

                    </el-col>

                    <el-col :span="7" class="marBo2">
                        <span class="inputT" style="width: auto;padding-right: 10px">商品名称：</span>
                        <el-input
                                v-model="Ggoodsname"
                                style="width: 100px"
                                placeholder="商品名称查询"
                                size="small"
                        >
                        </el-input>

                    </el-col>
                    <el-col :span="3" class="marBo2">
                        <el-button type="success"  size="mini" style="margin-right: 10px" @click="chaxun2" >查询</el-button>
                    </el-col>



                    <el-col :span="24">
                        <div class="tableBox" style="overflow-x: scroll">

                            <el-table
                                    ref="multipleTable"
                                    :data="Gdata"
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                    height="300"
                                    @selection-change="handleSelectionChange">
                                <el-table-column
                                        fixed
                                        type="selection"
                                        width="55">
                                </el-table-column>
                                <el-table-column
                                        label="商品编号"
                                        prop="good_num"
                                        width="150"
                                >
                                </el-table-column>

                                <el-table-column
                                        label="商品名称"
                                        prop="good_name"
                                >
                                </el-table-column>
                                <el-table-column
                                        label="图片"

                                >
                                    <template slot-scope="scope">

                                        <a :href="scope.row.imgpath"><img style="width: 26px;height: 26px" :src="scope.row.imgpath"  alt=""></a>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="规格"
                                        prop="spec"
                                >
                                </el-table-column>
                                <el-table-column
                                        label="单位"
                                        prop="unit"
                                >
                                </el-table-column>
                                <el-table-column
                                        label="销售价格"
                                        prop="real_price"
                                >
                                </el-table-column>
                                <el-table-column
                                        label="采购价"
                                        prop="purchase_price"
                                >
                                </el-table-column>
<!--                                <el-table-column-->
<!--                                        label="上次采购价"-->
<!--                                        prop="prev_purprice"-->
<!--                                        width="100"-->
<!--                                >-->
<!--                                </el-table-column>-->
                                <el-table-column
                                        label="可用库存"
                                        prop="stock"
                                >
                                </el-table-column>


                            </el-table>


                            <div class="table-bottom">
                                <div>
                                    <el-pagination
                                            @current-change="Gchange"
                                            :current-page="Gcurrentpage"
                                            :page-size="Gonepage"
                                            background
                                            layout="prev, pager, next"
                                            :total="Gtotal">
                                    </el-pagination>
                                </div>
                            </div>

                        </div>
                    </el-col>



                </el-row>
                <div style="display: flex;justify-content: center;align-items: center;margin-top: 15px;margin-bottom: 15px">
                    <el-button type="success" round size="mini" class="purBtnsz" style="height: 28px;" @click="addchanp" >添加</el-button>
                </div>
            </div>
        </el-dialog>
        <!--选择商品eee-->

    </div>
</template>

<script>

    export default {
        data() {
            return {
                token:'',
                gyshang:'',
                currentpage:1,
                pageone:10,
                total:100,
                chukglt:false,
                zhuang:'',
                Ttitle:'',
                dis:false,
                sgday:'',
//            shangphone:''
                goodsleiop:[],
                goodslei:'',
                ylimg:'https://saas.gymbaby.cn/static/qmsj/img/jinxiaocun/default2.jpg',
                imgbox:[],
                setime:'',

                type_id:'',
                search:'',
                tabledata:"",
                pagetotal:0,
                time_s:'',
                time_e:'',
                chaid:'',
                Korder_goods:'',
                Korder_info:'',
                addmeg:'',
                ruglt2:false,
                goodschecked:false,
                order_goods2:[],

                Ggood_types:'',
                Gdata:[],
                Gtotal:0,
                Gonepage:4,
                Gcurrentpage:1,
                Gsuppliers:'',
                Ggtype:'',
                Gsup:'',
                Ggoodsname:'',
                multipleSelection:'',
                heji:0,
                person:''

            };
        },
        methods:{
            quetj:function () {
                let self=this;
                var len = self.order_goods2.length
                for(var i =0;i<len;i++){
                    if(self.order_goods2[i].ship < 0){
                        self.$message.error("实盘数量不可小于零");
                        return;
                    }
                }

                var art_form = new FormData($('#ruku')[0]);
                $.ajax({
                    "type": "post",

                    "url": process.env.apiUrl + "saas/JxcOrder/storepd",
                    contentType: false,
                    processData: false,
                    "dataType": "json",
                    "data":art_form,
                    success: function(data){
                        if(data.status==1){

                            self.$message({
                                type: 'success',
                                message: data.msg
                            });
                          self.ruglt2 = false
                          self.gonggong()
                            // setTimeout(function(){
                            //     // location.reload()
                            //
                            // },1000)
                        }else{
                            self.$message({
                                type: 'error',
                                message: data.msg
                            });
                        }

                    }
                });
            },
            deletefn:function (i) {
                let self=this;

                self.order_goods2.splice(i,1)
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            addchanp:function () {
                let self=this;
                self.order_goods2=[...self.order_goods2,...self.multipleSelection]
                self.goodschecked=false;
            },
            Gchange:function (i) {
                let self=this;

                self.Gcurrentpage=i;
                self.addgonggong()
            },
            chaxun2:function () {
//          alert(11111)
                let self=this;
                self.addgonggong()
            },

            addgonggong:function () {
                let self=this;
                $.ajax({
                    type: 'POST',
                    url:process.env.apiUrl + 'saas/JxcGoods/goodslist',
                    dataType:'json',
                    data:{
                        token:self.token,
                        search:self.Ggoodsname,
                        typeid:self.Ggtype,
                        supplierid:self.Gsup,
                        page:self.Gcurrentpage,
                        pageone:4
                    },
                    success:function (data) {

                        self.Ggood_types=data.good_types;
                        self.Gdata=data.data;
                        self.Gtotal=Number(data.map.count)
                        self.Gsuppliers=data.suppliers
                    }
                })

            },





            tianjshangp:function () {
                let self=this;
                self.goodschecked=true;
                $.ajax({
                    type: 'POST',
                    url:process.env.apiUrl + 'saas/JxcGoods/goodslist',
                    dataType:'json',
                    data:{
                        token:self.token,
                        pageone:4,
                        page:1
                    },
                    success:function (data) {
                        self.Ggood_types=data.good_types;
                        self.Gdata=data.data;
                        self.Gtotal=Number(data.map.count)
                        self.Gsuppliers=data.suppliers


                    }
                })
            },
            tianjrk:function () {
                let self=this;
                self.ruglt2=true;
                $.ajax({
                    type: 'POST',
                    url:process.env.apiUrl + 'saas/JxcOrder/addpd',
                    dataType:'json',
                    data:{
                        token:self.token,
                    },
                    success:function (data) {
                        self.addmeg=data

                    }
                })

            },
            chaxun:function () {
                let self=this;
                self.currentpage=1;
                self.gonggong()
            },
            upimg:function () {
                let self=this;
                $('#img_upload').click()


            },
            fn:function (e) {
                this.ylimg=URL.createObjectURL(e.currentTarget.files[0])
            },
            tan:function (id) {
                let self=this;
                self.chaid=id;
                $.ajax({
                    type: 'POST',
                    url:process.env.apiUrl + 'saas/JxcOrder/showpd',
                    dataType:'json',
                    data:{
                        token:self.token,
                        id:self.chaid
                    },
                    success:function (data) {
                        self.Korder_goods=data.order_goods;
                        self.Korder_info=data.order_info;
                    }
                })


                this.chukglt=true;
            },
            handleCurrentChange:function (i) {
              let self=this;
              self.currentpage=i;
              self.gonggong()
            },
            searchname:function () {
                alert(this.gyshang)
            },
            jump:function (e) {
                this.$router.push({
                    'name':e
                })
            },
            tianj:function () {
                let self=this;

//            if(/^[0-9]{1,4}-[0-9]{1,8}$/.test(self.shangphone) ){
//                alert('格式正确！')
//            }else{
//                alert('格式不对！')
//            }
            },
            delfn:function (id) {

                let self=this;

                this.$confirm('确定删除该信息吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    //这里请求ajax
                    $.ajax({
                        type: 'POST',
                        url:process.env.apiUrl + 'saas/JxcOrder/deletepd',
                        dataType:'json',
                        data:{
                            id:id,
                            token:self.token,

                        },
                        success:function (data) {
                            if(data.status==1){

                                self.$message({
                                    type: 'success',
                                    message: data.msg
                                });
                                self.gonggong()
                            }else{
                                self.$message({
                                    type: 'error',
                                    message: data.msg
                                });
                            }



                        }
                    })
                }).catch(() => {
//                this.$message({
//                    type: 'info',
//                    message: '已取消删除'
//                });
                });


            },

            gonggong:function () {

                var self=this;
                self.time_s=$("input[name='time_s']").val()
                self.time_e=$("input[name='time_e']").val()
                $.ajax({
                    type: 'POST',
                    url:process.env.apiUrl + 'saas/JxcOrder/pd',
                    dataType:'json',
                    data:{
                        page:self.currentpage,
                        token:self.token,
                        search:self.search,
                        time_s:self.time_s,
                        time_e:self.time_e,
                        person:self.person
                    },
                    success:function (data) {
                        if(data.status==1){

                            self.tabledata=data.data;

                            self.total=Number(data.map.count)
                            self.currentpage=Number(data.map.page)
                            self.pagetotal=Number(data.map.pagetotal)
                            self.goodsleiop=data.users;
                        }else{
                            self.tabledata='';
                            self.total=0;
                            self.pagetotal=1;
                            self.currentpage=1
                        }

                    }
                })
            }


        },
        mounted:function(){
            var self=this;
            self.token=$.cookie('token');
            self.gonggong()

        }


    }
</script>

<style scoped>
    .xiala{
        width: 200px;
        height: 32px;
        line-height: 32px;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: 13px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);

    }
    .yulantu{
        width: 100px;
        height: 100px;
        border-radius: 6px;
        margin-left: 10px;
    }
    ul{
        list-style: none;
    }
    #chukgl p,label,ul{
        margin: 0;
        padding:0 ;
    }
    .fflex{
        display: flex;
        display:-webkit-flex;
    }
    .ffbet{
        justify-content: space-between;
    }
    .ffend{
        justify-content: flex-end;
    }
    #chukgl *{
        box-sizing: border-box;
    }
    #chukgl{
        box-sizing: border-box;
        padding: 10px;
    }
    .headBox li{
        width: 75px;
        background: #8CBB77;
        height: 30px;
        line-height: 30px;
        margin-right: 8px;
        border-radius:  5px 5px 0 0;
        text-align: center;
        color: #fff;

    }
    .headBox li.active{
        background: #ecebfd;
        color:#8CBB77 ;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    }
    .qzbtna{
        width: 75px;
        height: 30px;
        line-height: 30px;
        margin-right: 8px;
        border-radius:  5px 5px 0 0;
        text-align: center;
        background: #ecebfd;
        color:#8CBB77 ;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    }
    .purBtnsz{
        background: #8CBB77!important;
        height: 26px;
        border: none!important;
    }
    .marBo2{
        margin-bottom: 10px;
    }
    .inputT{
        display: inline-block;
        width: 100px;

    }



</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/kcpand.vue